<template>
  <div class="login-bar" @click="onLogin">
    <div class="text">
      <IconFont :name="leftIcon" color="#F45E33" size="12px" />
      {{ text }}
    </div>
    <div class="right-icon">
      <span>{{ rightIconText }}</span>
      <IconFont :name="rightIcon" color="#F45E33" size="12px" />
    </div>
  </div>
</template>

<script>
import { login } from '@/utils/native_interactions/login'

export default {
  name: 'LoginBar',
  props: {
    text: {
      type: String,
      default: ''
    },
    leftIcon: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: ''
    },
    rightIconText: {
      type: String,
      default: ''
    },
    spm: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    onLogin() {
      if (this.spm) {
        this.$track(this.spm)
      }
      login()
    }
  }
}
</script>

<style lang="scss" scoped>
.login-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;

  height: 0.8rem;
  padding: 0 0.32rem;

  background-color: #fff0db;

  @include flex(row, space-between, center);
  @include text(0.24rem, #ff5c00);
}
</style>
